<template>
  <b-modal v-model="modalShow" centered hide-header hide-footer no-close-on-backdrop>
    <div class="d-block text-center modal-container">
      <div class="content-subject">{{ $t('error.networkError') }}</div>
      <div class="content-desc">{{ $t('error.oparateFromTouchPanel') }}</div>
      <div>
        <b-button block class="close-button" @click="handleClose">{{
          $t('common.close')
        }}</b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      isShowingSimpleErrorModal: 'modal/isShowingSimpleErrorModal',
    }),
    modalShow: {
      get() {
        return this.isShowingSimpleErrorModal
      },
      set(value) {
        this.setShowingModal(value)
      },
    },
  },
  methods: {
    ...mapActions({
      setShowingModal: 'modal/setShowingSimpleErrorModal',
    }),
    handleClose() {
      this.setShowingModal(false)
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-container {
  padding-top: 8px;
  padding-bottom: 8px;
}
.content {
  color: #222222;
  &-subject {
    font-size: 18px;
    font-weight: bold;
  }
  &-desc {
    padding: 20px 0;
    font-size: 14px;
  }
}
.close-button {
  font-size: 18px;
  font-weight: bold;
  background-color: #d21b24;
  border-color: #d21b24;
  padding: 10px;
  margin: 40px 0 0;
}
</style>
